<template>
    <div>
        <span class="label published" v-if="!dateEnd && internalValue == 1">Publié</span>
        <span class="label expired_soon" v-if="dateEnd && internalValue == 1" :title="'Expiration le ' + formatDate(dateEnd)">
            Expire <datetime v-model="dateEnd" :human="true"></datetime>
        </span>
        <span class="label unpublished" v-if="internalValue == 0">Non publié</span>
        <span class="label expired" v-if="internalValue == -1"  :title="'Terminé le ' + formatDate(dateEnd)">Terminé <datetime v-model.number="dateEnd" :human="true"></datetime></span>
        <span class="label soon" v-if="internalValue == 2" :title="'Programmé le ' + formatDate(dateStart)">
            Programmé <datetime v-model="dateStart" :human="true"></datetime>
        </span>
    </div>
</template>

<script>
    export default {
        name: 'Published',
        props: ['value','label','name','placeholder','dateStart','dateEnd'],
        data: function () {
            return {
                internalValue: ''
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
            formatDate: function(value){
                //moment(value).tz('Europe/Zurich').format('DD.MM.YYYY HH:mm');
                return moment(value).format('DD.MM.YYYY HH:mm');
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Published.vue